var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-alert"},[(_vm.type)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.type))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }